import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, ListItem, ListItemIcon, ListItemText, Stack } from '@mui/material'
import InvoiceStatusChip from 'components/common/chip/InvoiceStatusChip'
import EventBlocker from 'components/common/EventBlocker'
import LateFeesPopover from 'components/pricing/LateFees/LateFeesListing/LateFeesPopover'
import { formatDateToFEFormat } from 'utils/date'
import { deriveInvoicePeriodLabel } from 'data/billing-period/invoicePeriodLabel'
import HHDisplayMoney from 'components/common/HHDisplayMoney'
import { getInvoiceIsPartialStatusAndBucket } from 'utils/agingBucket'
import PropTypes from 'prop-types'

const LateInvoiceItem = ({
  id,
  status,
  dueDate,
  amountPaidCents,
  totalCents,
  startDate,
  endDate,
  invoiceDate,
  type,
  invoiceNumber,
  lateFeeTargets,
  latestBatchStatus,
  latestBatchFailure,
}) => {
  const pendingAmount = totalCents - amountPaidCents
  const { isPartial, agingBucketType } = getInvoiceIsPartialStatusAndBucket(status, dueDate, amountPaidCents, totalCents)

  const transformDate = date => (date ? formatDateToFEFormat(date) : '-')
  const parsedInvoiceDate = transformDate(invoiceDate)
  const { label: title } = deriveInvoicePeriodLabel({ startDate, endDate, invoiceDate, type })

  return (
    <Accordion
      elevation={0}
      expanded={false}
      sx={{
        '&.Mui-expanded': {
          m: 0,
        },
        '& .MuiAccordionSummary-content.Mui-expanded, & .MuiAccordionSummary-content': {
          mb: 0,
          mt: 0,
        },
        '&:before': {
          display: 'none',
        },
      }}
      disablePointer
      expandIcon={undefined}
      iconGap={false}
    >
      <AccordionSummary
        sx={{
          p: 0,
        }}
      >
        <ListItem
          sx={{
            pr: 6,
          }}
          divider
        >
          <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
            <Stack direction="row" alignItems="center" columnGap={2}>
              <InvoiceStatusChip
                status={status}
                isPartial={isPartial}
                agingBucketType={agingBucketType}
                generationStatus={latestBatchStatus}
                generationFailure={latestBatchFailure}
              />
            </Stack>
          </ListItemIcon>
          <ListItemText
            primary={
              <>
                {`${title} | `}
                <HHDisplayMoney value={isPartial && agingBucketType ? pendingAmount : totalCents} />
                {isPartial && agingBucketType ? ' left' : ''}
              </>
            }
            secondary={`${invoiceNumber} | ${parsedInvoiceDate}`}
            slotProps={{
              primary: {
                variant: 'body1',
                fontWeight: 'bold',
                color: 'textPrimary',
              },

              secondary: {
                variant: 'body1',
                color: 'textSecondary',
              },
            }}
          />
          <EventBlocker>
            <LateFeesPopover lateFeeTargets={lateFeeTargets} invoiceId={id} />
          </EventBlocker>
        </ListItem>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          p: 0,
        }}
      />
    </Accordion>
  )
}

LateInvoiceItem.propTypes = {
  id: PropTypes.string,
  status: PropTypes.string,
  dueDate: PropTypes.string,
  amountPaidCents: PropTypes.number,
  totalCents: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  invoiceDate: PropTypes.string,
  type: PropTypes.string,
  invoiceNumber: PropTypes.string,
  lateFeeTargets: PropTypes.number,
  latestBatchStatus: PropTypes.string,
  latestBatchFailure: PropTypes.object,
}

export default LateInvoiceItem
